import { TimePicker } from '@monorepo/shared/componentsV2/dateAndTimePickers';
import { isTimeStringOrNullish } from '@monorepo/shared/utils/validators';
import { FORM_SUBMISSION_FIELD_TIME_FORMAT } from 'mapistry-shared';
import React from 'react';
import { useField } from 'react-final-form';
import styled from 'styled-components';
import { type ConditionalFieldValueInputProps } from './ConditionalFieldValueFactory';
import {
  conditionalDateTimePickerStyles,
  inputWithWhiteBackground,
} from './styled';

const StyledTimePicker = styled(TimePicker)<{ $isErrorTextShown: boolean }>`
  ${inputWithWhiteBackground}
  ${conditionalDateTimePickerStyles}
`;

export function ConditionalTimeField({
  name,
  ...inputFieldProps
}: ConditionalFieldValueInputProps['inputFieldProps']) {
  const {
    input: { onChange, value },
    meta,
  } = useField<string>(name, {
    validate: isTimeStringOrNullish(FORM_SUBMISSION_FIELD_TIME_FORMAT, {
      ampm: true,
    }),
  });

  const hasError = (meta.touched || meta.modified) && !!meta.error;

  return (
    <StyledTimePicker
      {...inputFieldProps}
      name={name}
      onChange={onChange}
      value={value}
      dataFormat={FORM_SUBMISSION_FIELD_TIME_FORMAT}
      ampm
      disableToolbar={false}
      dontSaveSpaceForErrorText
      $isErrorTextShown={!!hasError}
    />
  );
}
